var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labs-switch",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"ls-hotspot",on:{"click":_vm.cycle}}),_c('transition',{attrs:{"name":"ls"}},[(_vm.notice)?_c('span',{staticClass:"wt-note ls-note"},[_vm._v(_vm._s(_vm.notice))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }